export default __webpack_public_path__ + "static/media/16-Annual-Picnic-2018.bdbb18b6.jpeg";